/*  /frontend/src/pages/ForgotPassword.js
    Greatly Social – Forgot-Password screen
    FULL FILE — NOTHING OMITTED
    ------------------------------------------------------------------ */

import '../custom.css'

import React, { useState } from 'react'
import { Container, Row, Col, Image, Alert, Spinner, Button } from 'react-bootstrap'
import { CheckCircleFill } from 'react-bootstrap-icons'

/* ─── assets ─────────────────────────────────────────────────────── */
const logoUrl = '/assets/logo/greatly-social-full.png'

export default function ForgotPassword () {
  /* ------------- state ------------- */
  const [email, setEmail]     = useState('')
  const [loading, setLoading] = useState(false)
  const [msg, setMsg]         = useState({ text: '', variant: 'success' })

  /* ------------- submit ------------- */
  const handleSubmit = async e => {
    e.preventDefault()
    setMsg({ text: '', variant: 'success' })
    setLoading(true)

    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`
      const res = await fetch(url, {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify({ email }),
      })
      const data = await res.json()
      setMsg({ text: data.message, variant: 'success' })
    } catch (err) {
      console.error('[FORGOT-PW] network error', err)
      setMsg({ text: 'Network error – please try again.', variant: 'danger' })
    } finally {
      setLoading(false)
    }
  }

  /* ------------- ui ------------- */
  return (
    <section className='bg-light min-vh-100 d-flex align-items-center'>
      <Container>
        <Row className='justify-content-center'>
          <Col md={6} className='bg-white p-5 shadow-lg rounded-4'>
            <Image src={logoUrl} alt='Greatly Social logo' width={200} fluid className='mb-4' />

            <h2 className='fw-bold mb-4'>Forgot your password?</h2>

            {msg.text && (
              <Alert variant={msg.variant} className='d-flex align-items-center'>
                {msg.variant === 'success'
                  ? <CheckCircleFill className='me-2' />
                  : <span className='me-2'>❗</span>}
                {msg.text}
              </Alert>
            )}

            <form onSubmit={handleSubmit}>
              <div className='mb-4'>
                <label htmlFor='email' className='form-label'>E-mail</label>
                <input
                  id='email'
                  type='email'
                  className='form-control'
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />
              </div>

              <Button
                variant='primary'
                type='submit'
                disabled={loading}
                className='w-100'
                size='lg'
              >
                {loading ? <Spinner animation='border' size='sm' /> : 'Send reset link'}
              </Button>
            </form>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
